/* eslint-disable no-underscore-dangle */
/* eslint-disable react/forbid-prop-types */
import { Select, MenuItem } from '@material-ui/core';
import React, { useEffect, useState } from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import PropTypes from 'prop-types';
import { toastError } from '../../../redux/actions/alertActions';
import { groupServices } from '../../../redux/services/groupServices';
import { languageActions } from '../../../redux/actions/languageActions';

const LanguageSelector = ({ user, setLanguage }) => {
  const [languagesArr, setLanguagesArr] = useState([]);
  const [selectedLanguage, setSelectedLanguage] = useState('');
  const [loading, setLoading] = useState(true);

  const getData = async () => {
    if (user && user.type === 4) {
      try {
        const groupsRes = await groupServices.getGroupByUser(user._id);
        if (groupsRes && groupsRes.length > 0) {
          const languages = [];
          groupsRes.forEach((groupItem) => {
            let found = false;
            languages.forEach((languageItem) => {
              if (languageItem.initial === groupItem.language.initial) {
                found = true;
              }
            });
            if (!found) {
              languages.push({
                _id: groupItem.language._id,
                initial: groupItem.language.initial,
                name: groupItem.language.name,
              });
            }
          });
          setLanguagesArr(languages);
          let language;
          if (localStorage.getItem('language') !== 'undefined' && localStorage.getItem('language') !== undefined) {
            language = JSON.parse(localStorage.getItem('language'));
          }
          setLanguage(language || languages[0]._id);
          setSelectedLanguage(language || languages[0]._id);
          setLoading(false);
        }
      } catch (e) {
        toastError('Failed to fetch groups');
      }
    }
  };

  useEffect(() => {
    if (user && user._id) {
      getData();
    }
  }, [user]);

  return (
    <div>
      {!loading && (
      <Select
        labelId="demo-simple-select-label"
        id="demo-simple-select"
        value={selectedLanguage}
        color="inherit"
        label="Language"
        style={{
          color: '#E0E0E0',
          border: 'none !important',
          fill: '#E0E0E0',
          marginRight: '20px',
        }}
        onChange={(e) => {
          setLanguage(e.target.value);
          setSelectedLanguage(e.target.value);
          window.location.reload();
        }}
      >
        {languagesArr.map((language, index) => (
          <MenuItem key={`key-${index + 1}`} value={language._id}>{language.name}</MenuItem>
        ))}
      </Select>
      )}
    </div>
  );
};

LanguageSelector.propTypes = {
  user: PropTypes.object.isRequired,
  setLanguage: PropTypes.func.isRequired,
};

function mapState(state) {
  const { language } = state.language;
  return { language };
}

const actionCreators = {
  setLanguage: languageActions.setLanguage,
};

const connectedLanguageSelector = connect(mapState, actionCreators)(LanguageSelector);

export default withRouter(connectedLanguageSelector);
